<template>
  <div class="ht-empty-state">
    <div class="ht-empty-state__icon">
      <v-icon size="32" color="primary">{{ icon }}</v-icon>
    </div>
    <div class="ht-empty-state__title">{{ title }}</div>
    <div v-if="message" class="ht-empty-state__message">{{ message }}</div>
    <div v-if="$slots.default" class="ht-empty-state__actions">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// Empty / no-results placeholder. Presentation only.
export default {
  name: "EmptyState",
  props: {
    icon: { type: String, default: "mdi-inbox-outline" },
    title: { type: String, default: "No data found" },
    message: { type: String, default: "" },
  },
};
</script>

<style scoped>
.ht-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 40px 16px;
}

.ht-empty-state__icon {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e8eef2;
  margin-bottom: 12px;
}

.ht-empty-state__title {
  font-size: 1rem;
  font-weight: 600;
  color: var(--ht-text, #1f2d3d);
}

.ht-empty-state__message {
  margin-top: 4px;
  font-size: 0.8125rem;
  color: var(--ht-text-muted, #637381);
  max-width: 360px;
}

.ht-empty-state__actions {
  margin-top: 16px;
}
</style>
